<template>
    <div class="container reference-index-container">
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="card-header-label col-2">
                        <span class="mdi mdi-book-open-page-variant custom-icon"></span>
                        <span>Artículos</span>
                    </div>
                    <div class="card-header-search-bar col-5">
                        <b-form-input v-model="filter" id="filter-input"
                            placeholder="Escriba aquí el texto a buscar"></b-form-input>
                    </div>
                    <div class="card-header-pagination col-3">
                        <b-pagination v-model="currentPage" :total-rows="filteredList ? filteredList.length : 0"
                            :per-page="perPage" aria-controls="list-table" style="margin: 0"
                            align="center"></b-pagination>
                    </div>
                    <div class="card-header-action-buttons col-2">
                        <div>
                            <ButtonComponent :buttonText="'Refrescar'" :buttonColor="colors.BLUE_COLOR_BUTTON"
                                :buttonAction="getList" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isLoading" style="padding: 5ch 0">
                <SpeenComponent :isAutomatic="true" :ringWidth="14" :spinnerSize="15" :isverticalAligned="true" />
            </div>
            <div class="card-body" v-else>
                <b-table :items="filteredList" :fields="fields" small striped hover :per-page="perPage"
                    :current-page="currentPage" id="list-table">
                    <template #cell(ideal_cycle_time)="data">
                        <div style="display: flex; justify-content: space-around; align-items: center;">
                            <span>
                                {{ data.item.ideal_cycle_time }}
                            </span>
                            <span>
                                <ButtonComponent :buttonText="''" :buttonIcon="'mdi mdi-pencil'"
                                    :buttonColor="colors.GREEN_COLOR_BUTTON"
                                    :buttonAction="() => openEditModal(data.item)" 
                                    v-if="canEditReferenceICT"
                                    />
                                <ButtonComponent :buttonText="''" :buttonIcon="'mdi mdi-history'"
                                    :buttonColor="colors.BLUE_COLOR_BUTTON"
                                    :buttonAction="() => openHistoryModal(data.item)" />
                            </span>
                        </div>
                    </template>
                </b-table>
            </div>
        </div>
        <transition name="slide-fade">
            <ReferenceHistoryModal v-if="showHistoryModal" :referenceId="currentItemId"
                @close-modal="closeHistoryModal" />
        </transition>
        <transition name="slide-fade">
            <ReferenceEditModal v-if="showEditModal" :referenceExtPk="currentItemExtPk" @close-modal="closeEditModal"
                @refresh-list="getList" />
        </transition>
        <transition name="slide-fade">
            <ActionConfirmModal v-if="showActionConfirmModal" :contentMessage="actionConfirmModalMessage"
                :closeModal="closeActionConfirmModal" :methodForProp="methodForProp" />
        </transition>
    </div>
</template>

<script>
import axios from "axios";
import SpeenComponent from "../../common/components/SpeenComponent.vue";
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from "../../common/utils";
import ButtonComponent from "../../common/components/ButtonComponent.vue";
import Colors from "../../common/colors";
import ActionConfirmModal from "../../common/components/modals/ActionConfirmModal.vue";
import { filterList } from "../../common/utils";
import ReferenceEditModal from "../components/ReferenceEditModal.vue";
import ReferenceHistoryModal from "../components/ReferenceHistoryModal.vue";
import PermissionsConsts from "../../common/permissions";
import { mapGetters } from "vuex";

export default {
    name: "ReferenceIndexComponent",
    components: {
        SpeenComponent,
        ButtonComponent,
        ActionConfirmModal,
        ReferenceEditModal,
        ReferenceHistoryModal
    },
    data() {
        return {
            colors: Colors,
            perPage: 10,
            currentPage: 1,
            filter: '',
            listData: [],
            isLoading: true,
            showHistoryModal: false,
            showActionConfirmModal: false,
            showEditModal: false,
            currentItemExtPk: -1,
            actionConfirmModalMessage: '',
            methodForProp: null,
            fields: [
                { key: "code", label: "Código", sortable: true, class: "truncate" },
                { key: "descrip", label: "Nombre", sortable: true, class: "truncate" },
                { key: "brand", label: "Marca", sortable: true, class: "truncate" },
                { key: "variety", label: "Variedad", sortable: true, class: "truncate" },
                { key: "bags_per_Box", label: "Bolsas por caja", sortable: true, class: "truncate" },
                { key: "gross_weight", label: "Peso bruto", sortable: true, class: "truncate" },
                { key: "ideal_cycle_time", label: "Tiempo de ciclo ideal", sortable: true, class: "truncate" },
            ],
        };
    },
    computed: {
        ...mapGetters(['userHasPermission']),
        filteredList: function () {
            return filterList(this.listData, this.fields, this.filter);
        },
        canEditReferenceICT() {
            return this.userHasPermission(PermissionsConsts.REFERENCE_ICT_EDIT);
        }
    },
    methods: {
        getList() {
            this.isLoading = true;
            axios.get("/api/reference")
                .then((response) => {
                    this.listData = response.data;
                })
                .catch((error) => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        openHistoryModal(clickedItem) {
            this.currentItemId = clickedItem.id;
            this.showHistoryModal = true;
        },
        closeHistoryModal() {
            this.currentItemId = -1;
            this.showHistoryModal = false;
        },
        openEditModal(clickedItem) {
            this.currentItemExtPk = clickedItem.ext_pk;
            this.showEditModal = true;
        },
        closeEditModal() {
            this.currentItemExtPk = -1;
            this.showEditModal = false;
        },
    },
    mounted() {
        this.getList();
    },
};
</script>
